import { PropsWithChildren } from "react";

import { ActionContextProvider } from "@/components/modules/TaskActionBar";

export default function Container({ children }: PropsWithChildren) {
  return (
    <ActionContextProvider>
      <div className="absolute inset-0 flex overflow-hidden bg-background">
        {children}
      </div>
    </ActionContextProvider>
  );
}
